import React from 'react';
import { injectIntl } from 'react-intl';

function BooleanCell({ boolean, intl: { messages: m } }) {
  return <span>{boolean ? m.common_yes : m.common_no}</span>;
}

export default injectIntl(BooleanCell);
